import { useEffect, useState } from "react";

export type DetectSizeDeviceOutput = {
  isMobile: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  xxl: boolean;
  width: number;
};

export default (): DetectSizeDeviceOutput => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange(): void {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return {
    isMobile: width <= 639,
    sm: 640 <= width,
    md: 768 <= width,
    lg: 1024 <= width,
    xl: 1280 <= width,
    xxl: 1536 <= width,
    width
  };
};
